var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportCentre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Support-Centre",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(10.000000, 6.000000)",
    fill: "#62A9A9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.47830303,13.3851399 L4.47830303,12.3954545 C4.47830303,10.833042 5.1381157,9.55751748 6.76658953,8.46346154 L8.05813774,7.60437063 C8.9846832,6.9791958 9.37776309,6.22395105 9.37776309,5.33863636 C9.37776309,3.98444056 8.39506336,2.70891608 6.34543251,2.70891608 C4.26772452,2.70891608 3.05554821,4.19265734 3.05554821,5.67744755 L3.05554821,6.84912587 L-1.19823343e-13,6.84912587 L-1.19823343e-13,5.44248252 C-1.19823343e-13,2.83846154 2.10524518,2.22044605e-14 6.34543251,2.22044605e-14 C10.5008485,2.22044605e-14 12.7470193,2.5520979 12.7470193,5.20856643 C12.7470193,7.26608392 11.5677796,8.72412587 9.93930579,9.79143357 L8.73198898,10.5729021 C7.80544353,11.1713287 7.35620937,12.0309441 7.35620937,13.0463287 L7.35620937,13.3851399 L4.47830303,13.3851399 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06039559,15.4439642 C7.26370138,15.4439642 8.25642865,16.4485096 8.25642865,17.6303278 C8.25642865,18.812146 7.26370138,19.7877142 6.06039559,19.7877142 C4.82700716,19.7877142 3.86436253,18.812146 3.86436253,17.6303278 C3.86436253,16.4485096 4.82700716,15.4439642 6.06039559,15.4439642",
    id: "Fill-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836,0 32,7.164 32,16 C32,24.836 24.836,32 16,32 C7.163,32 0,24.836 0,16 C0,7.164 7.163,0 16,0 Z M16,3.5 C9.10714286,3.5 3.5,9.10714286 3.5,16 C3.5,22.8919643 9.10714286,28.5 16,28.5 C22.8928571,28.5 28.5,22.8919643 28.5,16 C28.5,9.10714286 22.8928571,3.5 16,3.5 Z",
    id: "Combined-Shape",
    fill: "#62A9A9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportCentre);
export default __webpack_public_path__ + "static/media/support-centre.411cbf265f706cd3a3c848a2f4934660.svg";
export { ForwardRef as ReactComponent };